export default angular
  // Module definition
  // ------------------------------------------------
  .module('app.services.state', ['ui.router'])
  .run(StateService => StateService.init())
  // Service
  // ------------------------------------------------
  .service('StateService', function($rootScope, $window, $state) {
    // If the service has already been initialized
    //
    // @type {Boolean}
    let self;
    let _initialized = false;

    // The last state before the current state
    //
    // @type {String}
    let _last = null;

    return (self = {
      // Initialize the service
      init() {
        if (_initialized) {
          return;
        }
        _initialized = true;

        $rootScope.$on('$stateChangeStart', function(
          event,
          toState,
          toParams,
          fromState,
          fromParams
        ) {
          // Set the last state
          if (fromState.name != null) {
            return (_last = $state.last = fromState.name);
          }
        });

        return $rootScope.$on('$stateChangeSuccess', function(
          event,
          toState,
          toParams,
          fromState,
          fromParams
        ) {
          // If the state has scrollTop set, then scoll to the top
          if (toState != null ? toState.scrollTop : undefined) {
            return $window.scrollTo(0, 0);
          }
        });
      },

      // Expose the last state property
      //
      // @return {String} The last state name
      last() {
        return _last || 'app.dashboard';
      },
    });
  });
